import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { certificationsData } from '../data/certifications';
import './Certifications.css';

const Certifications = () => {
  const data = certificationsData;

  return (
    <section id="certifications" className="certifications-section">
      <div className="section-heading fade-in-up">
        <h2>{data.heading}</h2>
        <p>{data.description}</p>
      </div>
      <div className="certifications-grid">
        {data.certifications.map((cert) => (
          <div key={cert.id} className="certification-card fade-in-up">
            <div className="certification-image">
              <img src={cert.image} alt={cert.name} />
            </div>
            <div className="certification-content">
              <h3 className="certification-name">{cert.name}</h3>
              <p className="certification-issuer">{cert.issuer}</p>
              <p className="certification-date">Issued: {cert.date}</p>
              <p className="certification-id">ID: {cert.credentialId}</p>
              <a
                href={cert.url}
                target="_blank"
                rel="noopener noreferrer"
                className="certification-link"
              >
                View Credential <FaExternalLinkAlt />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Certifications;

